import { RowRRProductionDetail } from './productions.types'
import FormLayoutDrawer from 'src/app/layout/form-layout/form-layout-drawer'
import { MovedProductionsGrid } from './moved-productions.grid'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'

type ProductionMovedDrawerProps = {
  propertyId: string
  rows: RowRRProductionDetail[]
  open: boolean
  onClose: () => void
}
export const ProductionMovedDrawer = (props: ProductionMovedDrawerProps) => {
  const { t } = useTranslation()
  const { lg } = useBreakpoints()

  return (
    <>
      <FormLayoutDrawer
        title={t('pms.booking.reservation.production_moved')}
        open={props.open}
        onClose={props.onClose}
        width={lg ? '50%' : '100%'}
        toolbar={
          <FormLayoutDefaultToolbar
            cancelButton={{
              text: t('commons.close'),
              clickHandler: props.onClose,
            }}
          />
        }
      >
        <MovedProductionsGrid propertyId={props.propertyId} rows={props.rows} />
      </FormLayoutDrawer>
    </>
  )
}
